import { DefaultChartProps } from "../types.ts";

// TODO - Mocked from old chart just date and error number
export interface ErrorData {
    date: string;
    error: number;
}

export interface IntegrationErrorBarChartProps extends DefaultChartProps {
    data: ErrorData[];
}
// TODO - Mocked, use real data
export const generateMockData = (): ErrorData[] => {
    const mockData: ErrorData[] = [];
    const startDate = new Date();

    for (let i = 0; i < 30; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() - i);

        mockData.push({
            date: date.toISOString().split("T")[0],
            error: 0,
        });
    }

    return mockData;
};
